export default __webpack_public_path__ + "static/media/icon_share.39e70059.svg";